$(() => {
  const toggleHeaderIcons = () => {
    document
      .querySelector(".shopping-basket-header-side__shop-section")
      .classList.toggle("shopping-basket-header-side__shop-section-off");
    document
      .querySelector(".shopping-basket-header-side__close-section")
      .classList.toggle("shopping-basket-header-side__close-section-on");
  };
  $("body").on("sidebarChange", () => toggleHeaderIcons());
});
